import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import InclusiveMarquee from "@/components/InclusiveMarquee";
import Amenities from "@/components/Amenities";
import AccommodationPlans from "@/components/AccommodationPlans";
import Gallery from "@/components/Gallery";
import Location from "@/components/Location";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

function App() {
  return (
    <div data-testid="app-root" className="min-h-screen bg-[#F9F6F0]">
      <Navbar />
      <Hero />
      <About />
      <InclusiveMarquee />
      <Amenities />
      <AccommodationPlans />
      <Gallery />
      <Location />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
